import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import Drawer from '@mui/material/Drawer';
import MenuIcon from '@mui/icons-material/Menu';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Link, useNavigate, useResolvedPath} from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
  borderRadius: `calc(${theme.shape.borderRadius}px + 8px)`,
  backdropFilter: 'blur(24px)',
  border: '1px solid',
  borderColor: (theme.vars || theme).palette.divider,
  backgroundColor: theme.vars
    ? `rgba(${theme.vars.palette.background.defaultChannel} / 0.4)`
    : alpha(theme.palette.background.default, 0.4),
  boxShadow: (theme.vars || theme).shadows[1],
  padding: '8px 12px',
}));

export default function AppAppBar(props) {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const navigate=useNavigate(); //You have to create a const that I can use to move around
  const location = useLocation(); //Same with location

  const onPeers=()=>{
    navigate('/peers');
  };

  const onHome=()=>{
    navigate('/');
  };

  const onReports=()=>{
    navigate('/reports');
  };

  const onHistorical=()=>{
    navigate('/historical');
  };

  const onUsers=()=>{
    navigate('/users');
  };

  const logOut=()=>{
    props.clearAllData();
    // Small delay to ensure state is cleared before navigation
    setTimeout(() => {
      navigate('/login', { replace: true });
    }, 100);
  };

  const logIn=()=>{
    navigate('/login');
  }

  const onFinancials=()=>
  {
    navigate('/financials');
  }

  const onAdminReports=()=>{
    navigate('/adminReports');
  }

  const edit=()=>{
    navigate('/editUsers');
  }

    React.useEffect(()=>{
      
      if(props.token==="" && location.pathname!=='/login')
      {
           navigate('/login');
      }
  });

  const onAdminEdit=()=>{
    navigate('/adminEdit');
  }

  const onEditCompanies=()=>{
    navigate('/editCompanies');
  }
  
if(props.isAdmin)
{
  return (
    <AppBar position="fixed">
        <Toolbar>
          {/* <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton> */}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Peer Group Reporting
          </Typography>
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
            <Box>
            <Button variant="text" color="" size="small" onClick={onHome}>
                Home
              </Button>
              <Button variant="text" color="" size="small" onClick={onAdminReports}>
                Reports
              </Button>
              <Button variant="text" color="" size="small" onClick={onUsers}>
                New User
              </Button>
              <Button variant="text" color="" size="small" onClick={edit}>
                Edit Users
              </Button>
              <Button variant="text" color="" size="small" onClick={onPeers}>
                Peers
              </Button>
              <Button variant="text" color="" size="small" onClick={onAdminEdit}>
                Admin Edit
              </Button>
              <Button variant="text" color="" size="small" onClick={onEditCompanies}>
                Edit Companies
              </Button>
            </Box>
          </Box>
          {!props.token?
            <Button color="" variant="text" size="small" onClick={logIn}>
              Sign in
            </Button>
            :
            <Button color="" variant="text" size="small" onClick={logOut}>
              Log Out
            </Button>
            }
        </Toolbar>
      </AppBar>
  );
}else{
  return(
    <AppBar position="fixed">
        <Toolbar>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Peer Group Reporting
          </Typography>
          {props.token?
          //Logged in
          <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', px: 0 }}>
            <Box>
              <Button variant="text" color="" size="small" onClick={onHome}>
                Home
              </Button>
              <Button variant="text" color="" size="small" onClick={onFinancials}>
                Financials
              </Button>
              <Button variant="text" color="" size="small" onClick={onReports}>
                Reports
              </Button>
              <Button variant="text" color="" size="small" onClick={onHistorical}>
                Historical
              </Button>
            </Box>
          </Box>
          :
          //Not Logged In
          <></>
          }
          {!props.token?
            <Button color="2222222222222222222" variant="text" size="small" onClick={logIn}>
              Sign in
            </Button>
            :
            <Button color="" variant="text" size="small" onClick={logOut}>
              Log Out
            </Button>
          }
      </Toolbar>
    </AppBar>
  );
}
}
